// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "integration_peertube-" + chunkId + ".js?v=" + {"reference-video-lazy":"002e2b118caa495680ca","vendors-node_modules_rehype-highlight_index_js":"cc2cbf95c2f1d7009f84"}[chunkId] + "";
};